import {
  faCity,
  faCog,
  faHome,
  faLandmark,
  faStore,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRouter } from "found";
import React from "react";
import { createFragmentContainer, graphql } from "react-relay";
import styled from "styled-components";
import { routes } from "../../routes";
import Spacer from "../Spacer";
import { AccountOptionsDropdown_account } from "./__generated__/AccountOptionsDropdown_account.graphql";

const MenuItem = styled.div`
  font-size: 14px;
  font-weight: 500;
  display: flex;
  padding: 13px 24px;
  border-radius: 0px;
  cursor: pointer;
  transition: all 0.1s;
  align-items: center;
  &:hover {
    background: #f7f7f9;
  }
`;

const CurrentAccount = styled.div`
  display: flex;
  padding: 16px 23px;
  align-items: center;
`;
const CurrentAccountName = styled.div`
  font-weight: 700;
  font-size: 16px;
`;

const AccountSettingsIcon = styled.div`
  padding: 7px 8px;
  border-radius: 100%;
  cursor: pointer;
  transition: all 0.2s;
  background: #f7f7f9;
  &:hover {
    background: #e9e9ef;
  }
  margin-left: auto;
`;

type Props = {
  account?: AccountOptionsDropdown_account;
  onClose: () => void;
  onAccountsClick: () => void;
};

const AccountOptionsDropdown = React.forwardRef(
  ({ account, onAccountsClick, onClose }: Props, ref: any) => {
    const { router } = useRouter();
    return (
      <div ref={ref}>
        <CurrentAccount>
          <FontAwesomeIcon
            color="#9092C1"
            icon={account?.userMembership.isDefault ? faHome : faLandmark}
          />
          <Spacer horizontal spacing={2} />
          <CurrentAccountName>{account?.name}</CurrentAccountName>
          <AccountSettingsIcon
            onClick={() => {
              router.push(routes.accountSettingsAccount);
              onClose();
            }}
          >
            <FontAwesomeIcon icon={faCog} color="#9092C1" />
          </AccountSettingsIcon>
        </CurrentAccount>
        <Spacer vertical spacing={1} />
        <MenuItem onClick={onAccountsClick}>
          <FontAwesomeIcon icon={faCity} color="#9092C1" />
          <Spacer horizontal spacing={2} />
          Teams
        </MenuItem>
        {!account?.merchant && (
          <MenuItem
            onClick={() => {
              router.push(routes.onboardMerchant);
              onClose();
            }}
          >
            <FontAwesomeIcon icon={faStore} color="#9092C1" />
            <Spacer horizontal spacing={2} />
            Sell on PayPI
          </MenuItem>
        )}
        <Spacer vertical spacing={1} />
      </div>
    );
  }
);

export default createFragmentContainer(AccountOptionsDropdown, {
  account: graphql`
    fragment AccountOptionsDropdown_account on Account {
      id
      name
      userMembership {
        isDefault
      }
      merchant {
        payments {
          stripeSetupStatus
        }
      }
    }
  `,
});
